<template>
  <v-form
    ref="rememberForm"
    v-model="isFormValid"
    class="authorization-form mt-3"
    @submit.prevent="submitForm"
  >
    <div class="authorization-form__label">
      Adres e-mail konta
    </div>

    <v-text-field
      v-model="email"
      class="authorization-form__field mb-0"
      :rules="[rules.required, rules.email]"
      v-bind="props.validatedField"
      placeholder="Wprowadź adres e-mail..."
    />

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      :loading="isLoading"
      type="submit"
      height="32"
      depressed
    >
      Odzyskaj hasło
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import props from '@/helpers/componentsProps';

export default {
  data() {
    return {
      rules: validationRules,
      props,
      email: '',
      isFormValid: true,
    };
  },

  computed: {
    ...mapState([
      'isLoading',
    ]),
  },

  methods: {
    ...mapActions('auth', [
      'recoverPassword',
    ]),

    submitForm() {
      this.$refs.rememberForm.validate();

      if (this.isFormValid) {
        this.recoverPassword({ email: this.email });
      }
    },
  },
};
</script>
